const state = {
    tableHeadStyle: {},
    tableHeight: document.documentElement.clientHeight - 220,
    navBreadList: [],
};
const getters = {
    getTableHeadStyle(state) {
        return {
            "background-color": "#F2F2F2",
            "font-weight": "700",
            color: "#333333",
        };
    },
    getTableHeight(state) {
        return state.tableHeight;
    },
    getNav() {
        return state.navBreadList;
    },
    getTableWhite(state) {
        return {
            "font-weight": "700",
            "border": "1px solid",
            "border-color": "#a6a6a6",
            color: "#a6a6a6",
        };
    },
    getTableCellWhite(state) {
        return {
            "border": "1px solid",
            "border-color": "#a6a6a6",
            color: "#003300",
        };
    }
};
const mutations = {
    setTableHeight(state) {
        state.tableHeight = document.documentElement.clientHeight - 220;
    },
    setNav(state, data) {
        state.navBreadList = data;
    }
};

export default {
    state,
    getters,
    mutations,
};